



























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class ContributionConfirmationModal extends Vue {
  themeStore = useThemeStore();
  accepted = false;
  submitting = false;

  @Prop({required: true})
  confirmModalVisible: boolean;

  onCancel (): void {
    this.accepted = false;
    this.$emit("cancel");
  }

  onSubmit (): void {
    this.submitting = true;
    this.$emit("confirm-contribution");
  }

  @Watch("confirmModalVisible")
  onConfirmModalVisibleChange () {
    if (!this.isMobile) {
      return;
    }

    if (this.confirmModalVisible) {
      this.hideFive9();
    } else {
      this.showFive9();
    }
  }

  get isMobile () {
    return window.innerWidth < 768;
  }

  get five9Iframe (): HTMLIFrameElement | null {
    return document.querySelector('iframe[src*="five9"]') as HTMLIFrameElement | null;
  }

  showFive9 () {
    if (this.five9Iframe) {
      this.five9Iframe.style.display = "";
    }
  }

  hideFive9 () {
    if (this.five9Iframe) {
      this.five9Iframe.style.display = "none";
    }
  }

  beforeDestroy () {
    if (this.isMobile) {
      this.showFive9();
    }
  }
}
